import { render, staticRenderFns } from "./transferCombTrusteeIn.vue?vue&type=template&id=a65dd5fc"
import script from "./transferCombTrusteeIn.vue?vue&type=script&lang=js"
export * from "./transferCombTrusteeIn.vue?vue&type=script&lang=js"
import style0 from "./transferCombTrusteeIn.vue?vue&type=style&index=0&id=a65dd5fc&prod&lang=scss"
import style1 from "./transferCombTrusteeIn.vue?vue&type=style&index=1&id=a65dd5fc&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports